import { forwardRef, ComponentPropsWithoutRef } from 'react'
import cl from 'clsx'

import { ICreative } from '@/shared/api'

export type CreativeBadgeProps = {
    data?: Omit<ICreative, 'active_in_site_links' | 'active_in_invite_links'>
    withHover?: boolean
} & Omit<ComponentPropsWithoutRef<'div'>, 'className'>
export const CreativeBadge = forwardRef<HTMLDivElement, CreativeBadgeProps>(
    function CreativeBadge({ data, withHover = false, ...props }, ref) {
        return (
            <div
                {...props}
                ref={ref}
                className={cl(
                    'overflow-hidden',
                    'min-w-0',
                    'grow',
                    'flex h-full max-h-[30px] items-center gap-[3px] rounded-md border border-[#CCCCCC] text-sm',
                    { ['hover:bg-gray-100']: withHover }
                )}
            >
                <img
                    src={data?.preview_url || '/img/placeholder.svg'}
                    alt=""
                    className="-ml-[1px] h-[30px] w-[30px] flex-shrink-0 rounded-[4px] object-cover"
                />
                <div className="line-clamp-2 py-[3px] text-left text-[10px] leading-tight">
                    {data?.extended_title ?? (data?.caption || data?.text)}
                </div>
            </div>
        )
    }
)
